export const formatJackpotNumber = (num: number, after: number): string => {
  return num.toLocaleString('en-US', { minimumFractionDigits: after, maximumFractionDigits: after });
};
